(ns app.front.view.admin.migration.enable-property-management-for-all-domains
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/enable-property-management-for-all-domains
    :title     "Enable property management for all domain groups"
    :help-text (str "This migration adds property-management user group, grant and authorization "
                    "to all local government domain groups that don't already have one. This enables basic PDM access "
                    "for all communities. Requires the property-db-units feature flag to be enabled.")}
   match])

(def route
  {:name        :view/admin.migration.enable-property-management-for-all-domains
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/enable-property-management-for-all-domains]))}]})
